import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Table from "./Table"
import { useSelector, useDispatch } from "react-redux"
import { getLeagues } from "helpers/repository"
import {sitename} from "../../../../constants/constants";

const Locations = props => {
  const dispatch = useDispatch()
  const [data, setData] = useState([])
  const [totalData, setTotalData] = useState(0)
  const [loadingMessage, setLoadingMessage] = useState("1");

  useEffect(() => {
    setLoadingMessage("1");
    getLeagues(getLeaguesSuccess, getLeaguesError)
    // dispatch(getAllSports())
  }, [])

  const getLeaguesSuccess = res => {
    setData(res?.data?.data ?? [])
    setTotalData(res.data.total)
    setLoadingMessage("0");
  }

  const getLeaguesError = error => {}

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Leagues" />
        </Container>
        <Table
          data={data}
          getLeagues={() => {
            getLeagues(getLeaguesSuccess, getLeaguesError)
          }}
          count={totalData}
          loadingMessage={loadingMessage}
          setLoadingMessage={setLoadingMessage}
        />
      </div>
    </React.Fragment>
  )
}

export default withRouter(Locations)
